import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { authenticate, setJwt } from "./api";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("root element missing");

// Best-effort Telegram WebApp auth before mount. We try to read initData from
// the WebApp object if present and authenticate against apps-api; without it
// the app still loads (the result screen falls back to "leaderboard
// unavailable").
(async () => {
  try {
    const tg = (
      window as unknown as {
        Telegram?: {
          WebApp?: {
            initData?: string;
            ready?: () => void;
            expand?: () => void;
            disableVerticalSwipes?: () => void;
            enableClosingConfirmation?: () => void;
            viewportStableHeight?: number;
            onEvent?: (name: string, cb: (e: { isStateStable?: boolean }) => void) => void;
          };
        };
      }
    ).Telegram?.WebApp;
    if (tg) {
      tg.ready?.();
      tg.expand?.();
      // Without this the bottom row of touch buttons fights TG's
      // swipe-down-to-dismiss gesture and taps are silently swallowed.
      tg.disableVerticalSwipes?.();
      const setVh = (h: number) => {
        document.documentElement.style.setProperty("--tg-vh", h + "px");
      };
      setVh(tg.viewportStableHeight ?? window.innerHeight);
      // Gate on isStateStable — keyboard popups fire viewportChanged too,
      // and we don't want to resize the canvas mid-race for an IME.
      tg.onEvent?.("viewportChanged", (e) => {
        if (e?.isStateStable && tg.viewportStableHeight) {
          setVh(tg.viewportStableHeight);
        }
      });
      const raw = tg.initData;
      if (raw) {
        const jwt = await authenticate(raw);
        setJwt(jwt);
      }
    }
  } catch (err) {
    console.warn("auth skipped:", err);
  }
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
})();
